import Link from 'next/link';
import React from 'react';

import { BlurImage } from './blur-image';
import { strapiImage } from '@/lib/strapi/strapiImage';
import { cn } from '@/lib/utils';
import { Image } from '@/types/types';

export const Logo = ({
  image,
  locale,
  className,
  textColor = 'text-black dark:text-white',
}: {
  image?: Image;
  locale?: string;
  className?: string;
  textColor?: string;
}) => {
  if (image) {
    return (
      <Link
        href={`/${locale || 'en'}`}
        className={cn(
          'font-normal flex space-x-2 items-center text-sm mr-4 relative z-20',
          className
        )}
      >
        <BlurImage
          src={strapiImage(image?.url)}
          alt={image.alternativeText || 'Veosis'}
          width={200}
          height={200}
          className="h-10 w-10 rounded-xl mr-2 object-contain"
        />

        <span className={cn('font-bold text-[2rem] tracking-tight', textColor)}>
          Veosis
        </span>
      </Link>
    );
  }

  return null;
};
